import { Component, OnInit, Input, Inject } from "@angular/core";
import { MatBottomSheet, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";

@Component({
  selector: "app-warning-sheet",
  templateUrl: "./warning-sheet.component.html",
  styleUrls: ["./warning-sheet.component.css"]
})
export class WarningSheetComponent implements OnInit {
  private _message: string = "";

  @Input()
  public set message(message: string) {
    this._message = (message && message.trim()) || "";
  }

  public get message(): string {
    return this._message;
  }
  constructor(private bottomSheet: MatBottomSheet, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
    this.message = data.message;
  }
  ngOnInit() {}
}
